/**
 * Версия сборки.
 *
 * Значения подставляются на этапе сборки (см. define в vite.config.ts).
 * Показывать их обязательно: без версии пользователь не может сказать,
 * какой именно код у него выполняется, и проверить его состав.
 */
export const APP_VERSION = __APP_VERSION__;
export const BUILD_TIME = __BUILD_TIME__;
